import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DebounceDirective} from './debounce.directive';
import {AutosizeDirective} from './autosize.directive';
import {AutofocusDirective} from './autofocus.directive';
import {LoadingDirective} from './loading.directive';
import {LoadingComponent} from '../loading/loading.component';
import {LoadingErrorComponent} from '../loading/loading-error/loading-error.component';
import {LoadingEmptyComponent} from '../loading/loading-empty/loading-empty.component';
import { LoadingModule } from '../loading/loading.module';
import { TooltipDirective } from './tooltip-directive/tooltip.directive';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule
  ],
  declarations: [DebounceDirective, AutosizeDirective, AutofocusDirective, LoadingDirective, TooltipDirective],
  exports: [DebounceDirective, AutosizeDirective, AutofocusDirective, LoadingDirective, TooltipDirective]
})
export class QmDirectivesModule {
}
